<template>
  <TemplateModal
    ref="modal"
    center
    width="435"
    :text="{
      button: {
        open: localStorage.translations.pages.projects.reports_dialogs.create_report,
        create: localStorage.translations.pages.projects.reports_dialogs.generate_report,
      },
      title: {
        create: localStorage.translations.pages.projects.reports_dialogs.create_report,
      },
    }"
    :sendFunction="onCreateReport"
  >
    <div class="form_item">
      <label>{{ localStorage.translations.pages.projects.reports_dialogs.generate_report }}</label>
      <transition name="fade" mode="out-in">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              hide-details="auto"
              v-model="dateRangeText"
              outlined
              v-bind="attrs"
              readonly
              prepend-inner-icon="today"
              :placeholder="localStorage.translations.pages.common['text'].not_selected"
              v-on="on"
              :rules="[inputRules.required]"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$cookies.get('languageSelect').key"
            v-model="data.dates"
            range
            no-title
            show-week
            first-day-of-week="1"
            :max="new Date().toISOString().slice(0, 10)"
            class="temp"
          >
            <BaseButton
              class="ml-auto mr-0"
              :text="localStorage.translations.pages.common.buttons.confirm"
              :disabled="data.dates.length < 1"
              @click="menu1 = false"
            />
          </v-date-picker>
        </v-menu>
      </transition>
    </div>
  </TemplateModal>
</template>

<script>
// import UsersListItem from 'components/setting/users/UsersListItem'
import TemplateModal from 'components/templates/TemplateModal'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseButton from "components/base/BaseButton";

export default {
  name: 'StatisticProjectReportsModal',
  props: {
    edit: Boolean,
  },
  components: {
    BaseButton,
    TemplateModal,
  },
  data: () => ({
    dialog: false,
    search: '',
    name: null,
    menu1: false,
    data: {
      dates: [],
    },
  }),
  watch: {
    'data.dates'() {
      if (this.data.dates[0] && this.data.dates[1] && this.data.dates[0] > this.data.dates[1]) {
        this.data.dates = [this.data.dates[1], this.data.dates[0]]
      }
    },
  },
  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    dateStartFormatted() {
      return this.$formatDate(this.data.start_date)
    },
    dateRangeText() {
      let dates = [...this.data.dates]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      return dates.join(' - ')
    },
  },
  methods: {
    ...mapActions('workClientProjectsPeriodReport', [
      'onWorkClientProjectsPeriodReportGrid',
      'onWorkClientProjectsPeriodReportCreate',
    ]),
    ...mapMutations('workClientProjectsPeriodReport', ['setWorkClientProjectsPeriodReportShow']),
    defaultData() {
      this.data = {
        dates: [],
      }
    },
    onCreateReport() {
      let data = {
        project_id: this.$route.params.id,
        start_date: this.data.dates[0],
        end_date: this.data.dates[1] ? this.data.dates[1] : this.data.dates[0],
      }
      this.onWorkClientProjectsPeriodReportCreate(data)
        .then((resp) => {
          // this.onWorkClientProjectsPeriodReportGrid({
          //     limit: this.$route.query.limit,
          //     page: this.$route.query.page,
          //     project_id: this.$route.params.id,
          // })
          let respData = resp.data
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },

            { root: true },
          )
          this.setWorkClientProjectsPeriodReportShow(respData)
          this.$router.push({
            name: 'timeControlShowReportsView',
            params: {
              report_id: respData.id,
            },
            query: {
              start: respData.start_date,
              end: respData.end_date,
            },
          })
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['oshibka'] +
                ' ' +
                err.response.data.message,
              IsError: true,
            },
            { root: true },
          )
        })

      // this.$router.push({
      //     name: 'timeControlShowReportsView',
      //     query: {
      //         start: this.data.dates[0],
      //         end: this.data.dates[1] ? this.data.dates[1] : this.data.dates[0],
      //     },
      // })
    },
  },
}
</script>

<style scoped lang="scss">
:deep() .v-date-picker-table {
  height: auto !important;
}
.temp {
  :deep() .v-input__slot{
  width: max-content !important;
  }
}
</style>
